import { environment as base } from '@haleo-frontend/utils';

export const environment = {
    ...base,
    appId: 'ca.haleo.screener-app.prod',
    sentryDSN: 'https://3c563d3c52ea4558b9670c2b82e7510e@sentry-relay.haleo.ca/4504323173515264',
    firebaseConfig: {
        apiKey: "AIzaSyDQpMgAsB38ewHrnplgn6WctrfMGcts_Qs",
        authDomain: "haleo-screener-v3.firebaseapp.com",
        projectId: "haleo-screener-v3",
        storageBucket: "haleo-screener-v3.appspot.com",
        messagingSenderId: "511436099896",
        appId: "1:511436099896:web:4eb5932303b479ab1b31cd",
        measurementId: "G-6EZCYNXVZY",
    },
    fileReplacements: [
        {
          "replace": "src/index.html",
          "with": "src/index.prod.html"
        }
    ],
    recaptchaSiteKey: '6Lep_0EnAAAAAKvxim2UZcXDQqd_7oUO6oIa1QzJ',
};
